import styled, { keyframes } from 'styled-components'
import { margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const scrollAnimation = keyframes`
  to {
    transform: translateX(calc(-50% - 20px));
  }
`

export const Container = styled.div<MarginProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  width: 100%;

  > div[data-animated='true'] {
    overflow: hidden;

    > div {
      flex-wrap: nowrap;
      justify-content: flex-start;
      animation-play-state: paused;
    }
  }

  > div[data-animation-running='true'] > div {
    animation-play-state: running;
  }

  ${margin}
`

export const Scroller = styled.div`
  display: flex;
  width: 100%;
  mask-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 1) 20%,
    rgba(0, 0, 0, 1) 80%,
    transparent 99%
  );
`

export const ScrollerInner = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${themeGet('space.8')}px;
  animation: ${scrollAnimation} 120s linear infinite;
`

export const StyledImage = styled.img`
  max-height: 100px;
  border-radius: 50%;

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    max-height: 120px;
  }
`
